import {IOpenOrderViewSettings} from './ao-open-order-view-settings.interface';

//#region DEFAULT _DEFAULT_OPEN_ORDER_VIEW_SETTINGS
export const _DEFAULT_OPEN_ORDER_VIEW_SETTINGS: Readonly<IOpenOrderViewSettings> = {
  inclDaysZero: false,
  inclDaysNegative: false,
  mainSupplierItems: true,
  meetOrderLevel: false,
  otherSupplierItems: false,
  packSize: false,
  showLineColours: true,
  subtractPurchaseOrders: true,
} as const;

//#endregion